export const getCorrectLdapPaths = (LdapPaths) => {
  const newFormatLdapPaths = [];
  LdapPaths.forEach((item, index) => {
    newFormatLdapPaths.push({ Id: index, Name: item });
  });
  return newFormatLdapPaths;
};
